import { appStorage } from './betaStorage'
export interface CaseNoteRecord {
  id: string
  authorId: string
  title: string
  body: string
  createdAt: string
  allowedUserIds: string[]
}

const STORAGE_KEY = 'schub.caseNotes.v1'

export function loadCaseNotes(): CaseNoteRecord[] {
  try {
    const raw = appStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

export function saveCaseNote(note: CaseNoteRecord): void {
  const existing = loadCaseNotes().filter((item) => item.id !== note.id)
  appStorage.setItem(STORAGE_KEY, JSON.stringify([note, ...existing]))
  window.dispatchEvent(new Event('schub-case-notes-updated'))
}

export function visibleCaseNotes(userId: string): CaseNoteRecord[] {
  return loadCaseNotes().filter(
    (note) => note.authorId === userId || note.allowedUserIds.includes(userId),
  )
}

